import { actionCreatorFactory } from '@core/utils/factories';
import { Candidate } from '@models/interfaces';

const actionCreator = actionCreatorFactory('CANDIDATES');

export namespace CandidatesActions {
  export const getCandidatesDataAction =
    actionCreator.createAsyncAction<Candidate[]>('GET_CANDIDATES');
}
